import { Observable, BehaviorSubject } from 'rxjs';

export class UpgradeProcess {
    constructor(
        public buttonText: string,
        public action: () => Promise<any>,
        public commandId: number,
        public testIdButton?: string,
        public testIdLabel?: string
    ){}

    public commandResult$: Observable<any>;

    public success: boolean;

    public error: boolean;

    public state: string;

    public styleClass: string;

    public subject: BehaviorSubject<any>;

    public async exec(){
        this.success = false;
        this.error = false;
        this.styleClass = 'right-aligned process-text';
        this.state = 'loading';
        this.subject = new BehaviorSubject({
            message: 'wird durchgeführt ...',
            payload: null,
            status: 5
        });
        this.commandResult$ =  this.subject.asObservable();
        const result = await this.action();
        if(result) {
            this.subject.next(result);
            /*
            const subscription = action$.subscribe((value: any) => {
                sub.next(value);
                if(value.status === 4 || value.status === 0){
                    setTimeout(() => subscription.unsubscribe());
                }
            });*/
        }else{
            this.subject.next({
                message: '',
                payload: null,
                status: 7
            });
        }
    }
}
